import { defineStore } from "pinia";

import { ACTION_EXTRA_GET_BY_ID, ACTION_EXTRA_GET_SKILLS_BY_ID, GETTER_EXTRA_GET_CURRENT, GETTER_EXTRA_GET_SKILLS } from "@etab/stores/types";
import { ExtraModel } from "@core/models";
import { ExtraService } from "@core/services";

export const useExtraStore = defineStore("extra", {
  // convert to a function
  state: () => ({
    extra: {},
    skills: [],
  }),
  getters: {
    [GETTER_EXTRA_GET_CURRENT]: (state) => new ExtraModel(state.extra),
    [GETTER_EXTRA_GET_SKILLS]: (state) => state.skills,
  },
  actions: {
    async [ACTION_EXTRA_GET_BY_ID]({ extraId, demandId, type }) {
      const extra = await ExtraService.getById({ extraId, demandId, type });
      this.extra = extra;
    },
    async [ACTION_EXTRA_GET_SKILLS_BY_ID]({ candidateId }) {
      const skills = await ExtraService.getSkillsById({ candidateId });
      this.skills = skills;
    },
    // easily reset state using `$reset`
    clearExtraStore() {
      this.$reset();
    },
  },
});
